import React from 'react'

export interface QuizResult {
  total_questions: number
  total_correct_answer: number
  total_incorrect_answer: number
  obtain_mark_percent: number
  result_status: 'passed' | 'failed'
  answers: {
    questionId: string
    selectedAnswerId: string
    isCorrect: boolean
  }[]
}

interface ResultsProps {
  result?: QuizResult
}
const Results: React.FC<ResultsProps> = ({result}) => {
  const scoreColor = result?.result_status === 'passed' ? 'success' : 'danger'
  const scoreMessage =
    result?.result_status === 'passed' ? 'Good Job! 🎉' : 'Better Luck Next Time! 🍀'

  return (
    <div className='card shadow-sm'>
      {/* <div className='card-header bg-primary text-white text-center py-4'>
        <h2 className='mb-0'>Test Completsed!</h2>
      </div> */}

      <div className='card-body p-5'>
        {!result ? (
          // Message when results are not shown to students
          <div className='text-center py-5'>
            <div className='mb-4'>
              <i
                className='bi bi-check-circle fs-1 text-primary d-block mb-3'
                style={{fontSize: '5rem'}}
              ></i>
            </div>
            <h2 className='text-primary mb-4'>Test Submitted Successfully! ✓</h2>
            <p className='text-muted fs-5 mb-4'>Your answers have been submitted successfully.</p>
            <p className='text-muted fs-6 mb-5'>Results will be shared at a later time.</p>
            <div className='text-center'>
              <button className='btn btn-primary btn-lg px-5' onClick={() => window.close()}>
                <i className='bi bi-x-circle me-2'></i>
                Close Page
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className='text-center mb-5'>
              <div
                className={`display-1 fw-bold text-${scoreColor} mb-3`}
                style={{fontSize: '5rem'}}
              >
                {result.obtain_mark_percent}%
              </div>
              <h3 className={`text-${scoreColor} mb-2`}>{scoreMessage}</h3>
              <div className='mb-3'>
                <span className={`badge badge-lg fs-4 px-5 py-3 badge-${scoreColor}`}>
                  {result.result_status.toUpperCase()}
                </span>
              </div>
              <p className='text-muted'>
                You answered {result.total_correct_answer} out of {result.total_questions} questions
                correctly.
              </p>
            </div>

            <div className='row text-center mb-4'>
              <div className='col-md-4 mb-3 mb-md-0'>
                <div className='card bg-light'>
                  <div className='card-body'>
                    <i className='bi bi-list-check fs-1 text-primary d-block mb-2'></i>
                    <h5 className='mb-1'>Total</h5>
                    <p className='fs-3 fw-bold text-dark mb-0'>{result.total_questions}</p>
                  </div>
                </div>
              </div>
              <div className='col-md-4 mb-3 mb-md-0'>
                <div className='card bg-success bg-opacity-10 border-success'>
                  <div className='card-body'>
                    <i className='bi bi-check-circle fs-1 text-success d-block mb-2'></i>
                    <h5 className='mb-1'>Correct</h5>
                    <p className='fs-3 fw-bold text-success mb-0'>{result.total_correct_answer}</p>
                  </div>
                </div>
              </div>
              <div className='col-md-4'>
                <div className='card bg-danger bg-opacity-10 border-danger'>
                  <div className='card-body'>
                    <i className='bi bi-x-circle fs-1 text-danger d-block mb-2'></i>
                    <h5 className='mb-1'>Incorrect</h5>
                    <p className='fs-3 fw-bold text-danger mb-0'>{result.total_incorrect_answer}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className='mb-4'>
          <h5 className='mb-3'>Question Review:</h5>
          <div className='list-group'>
            {result.answers.map((answer, index) => {
              const question = quiz.questions.find((q) => q.id === answer.questionId)
              const selectedAnswer = question?.answers.find((a) => a.id === answer.selectedAnswerId)
              const correctAnswer = question?.answers.find((a) => a.isCorrect)

              return (
                <div
                  key={answer.questionId}
                  className={`list-group-item ${
                    answer.isCorrect ? 'list-group-item-success' : 'list-group-item-danger'
                  }`}
                >
                  <div className='d-flex w-100 justify-content-between align-items-start'>
                    <h6 className='mb-2'>
                      <span className='badge bg-dark me-2'>{index + 1}</span>
                      {question?.text}
                    </h6>
                    {answer.isCorrect ? (
                      <i className='bi bi-check-circle-fill text-success fs-5'></i>
                    ) : (
                      <i className='bi bi-x-circle-fill text-danger fs-5'></i>
                    )}
                  </div>
                  <p className='mb-1'>
                    <strong>Your answer:</strong> {selectedAnswer?.text}
                  </p>
                  {!answer.isCorrect && (
                    <p className='mb-0 text-success'>
                      <strong>Correct answer:</strong> {correctAnswer?.text}
                    </p>
                  )}
                </div>
              )
            })}
          </div>
        </div> */}

            <div className='text-center'>
              <button className='btn btn-primary btn-lg px-5' onClick={() => window.close()}>
                <i className='bi bi-x-circle me-2'></i>
                Close Page
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Results
